import { createContext } from "react"
import type { InsightsState } from "src/types"

export interface InsightsContextValue {
  insightsState: InsightsState;
  setInsightsState: (v: InsightsState) => void;
}

type ContextType = InsightsContextValue | null

export const InsightsContext = createContext<ContextType>(null)
